"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserDataForDigitalFingerPrint = void 0;
var facct_1 = require("./facct");
var bizone_1 = require("./bizone");
var cybertronics_1 = require("./cybertronics");
var setUserDataForDigitalFingerPrint = function (_a) {
    var _b = _a === void 0 ? {} : _a, userId = _b.userId, sessionId = _b.sessionId, locale = _b.locale;
    (0, facct_1.callWindowGib)(function () {
        var _a, _b, _c, _d;
        (_a = window.gib) === null || _a === void 0 ? void 0 : _a.setAuthStatus(userId ? window.gib.IS_AUTHORIZED : window.gib.IS_GUEST);
        if (userId) {
            (_b = window.gib) === null || _b === void 0 ? void 0 : _b.setIdentity(String(userId));
        }
        if (sessionId) {
            (_c = window.gib) === null || _c === void 0 ? void 0 : _c.setSessionID(String(sessionId));
        }
        if (locale) {
            (_d = window.gib) === null || _d === void 0 ? void 0 : _d.setAttribute('user_locale', locale, { persistent: true, encryption: null });
        }
    });
    (0, bizone_1.callWindowBizone)(function () {
        var _a, _b;
        if (userId) {
            (_b = (_a = window.bfd) === null || _a === void 0 ? void 0 : _a.utils) === null || _b === void 0 ? void 0 : _b.auth(String(userId));
        }
    });
    (0, cybertronics_1.callWindowCybertronics)(function () {
        var _a;
        if (userId) {
            (_a = window.AFCYBERTONICA) === null || _a === void 0 ? void 0 : _a.setUserId(String(userId));
        }
    });
};
exports.setUserDataForDigitalFingerPrint = setUserDataForDigitalFingerPrint;
//# sourceMappingURL=set-user-data-for-digital-finger-print.js.map